import { Component, OnInit, OnDestroy,ViewChild  } from '@angular/core';
import { AlertService } from '../../servicios/alert.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Result } from '../../servicios/servers.service';
import { TipoServicioService } from '../../servicios/tiposervicio.service';
import { PersonaService } from '../../servicios/persona.service';
import { VehiculoService } from '../../servicios/vehiculo.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { EmpresaService } from '../../servicios/empresa.service';
import { BsModalComponent,BsModalService  } from 'ng2-bs3-modal';
declare var jQuery: any;

@Component({
    selector: 'conductores',
    templateUrl: 'conductores.template.html'
})

export class ConductoresComponent implements OnInit, OnDestroy {
    
    constructor(
        private modalservice: BsModalService,
        private personaService: PersonaService,
        private alertService: AlertService,
        private tipoServicioService: TipoServicioService,
        private vehiculoService: VehiculoService,
        private empresaService: EmpresaService,
        private router: Router,
        private route: ActivatedRoute
    ) {

    }

    @ViewChild('modal')
    public modal: BsModalComponent;
    @ViewChild('modal2')
    public modal2: BsModalComponent;
    @ViewChild('modal3')
    public modal3: BsModalComponent;

    @ViewChild('video') video:any; 
    public sub:any;
    public filter = "";
    public conductor:any= {placa:""};
    public aux: any;
    public vehiculo = null;
    public conductores = [];
    public empresas = [];
    public update = false;
    public valorRecarga = 0;
    public crop:boolean = true;


    public cropper:any;


    public printer_list = [];

    cancelarRecarga() {
        this.valorRecarga=0;
        this.modal.close();
    }
    
    recargar() {
        let user:any = JSON.parse( localStorage.getItem("user") );
        
        var object = {
            'idUsuario': user.id,
            'idPersona': this.conductor['idPersona'],
            'valor': this.valorRecarga
        }

        console.log(object);

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.saveRecarga(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {

                this.modal.close();
                this.valorRecarga=0;
                this.conductor = {placa:""};
                jQuery("#placa").removeAttr("disabled");
                this.vehiculo = null;
                this.alertService.success(data.Mensaje);
                this.getConductores();
            }else{
                this.alertService.error(data.Mensaje);
            }
        });
    }

    modalRecarga(conductor:any){
        this.conductor = conductor;
        this.modal.open();
    }
    
    ngOnInit() {

        this.sub = this.route
        .queryParams
        .subscribe(params => {
           
          // Defaults to 0 if no query param provided.
          if("placa" in params){

            this.conductor = params || {};
            this.buscarPlaca();
            
          }
          
        });
        
        this.getConductores();
        this.getEmpresas();
        this.initCropper();
        //this.probar();

    }

    tomarFoto(){
        
    }

    webCam(){
        this.crop =false;
 
        let _video = this.video.nativeElement;
        //var video:any = document.getElementById("v");
        let canvas:any = document.getElementById("c");
        let button:any = document.getElementById("b");
        jQuery("#v").show();
        let finalWidth = 100;
        let finalHeight = 150;

        let __this = this;

        

        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {

                _video.src = window.URL.createObjectURL(stream);
                _video.play();
                button.disabled = false;

                button.onclick = function() {

                    jQuery("#v").hide();
                    
                    jQuery(".image-crop").empty();
                    canvas.getContext("2d").drawImage(_video,0,0,254,190.5);

                    var img = new Image();
                    img.id = "preview";
                    img.src = canvas.toDataURL("image/png");
                    //_video.stop();

                    __this.crop =true;

                    
                    jQuery(".image-crop").append(img);

                    __this.cropper= jQuery(".image-crop > img");
                    __this.cropper.css("max-width"," 100%");
                    __this.cropper.cropper({
                        aspectRatio: 2/3,
                        preview: ".img-preview",
                        done: function(data) {
                            alert(data);
                            // Output the result data for cropping image.
                        }
                    });

                    
                };

            })
        }
        
        /*navigator.getUserMedia({video: true}, function(stream) {
            ;
            video.src = stream;
            button.disabled = false;
            button.onclick = function() {
                
                canvas.getContext("2d").drawImage(video, 0, 0, 300, 300, 0, 0, 300, 300);
                var img = canvas.toDataURL("image/png");
                alert("done");

            };
        }, function(err) { alert("there was an error " + err)});*/
    }
    
    zoomIn(){
        jQuery(".image-crop > img").cropper("zoom", 0.1);
    }
    zoomOut(){
        jQuery(".image-crop > img").cropper("zoom", -0.1);
    }

    rotateLeft(){
        jQuery(".image-crop > img").cropper("rotate", 45);
    }
    
    rotateRight(){
        jQuery(".image-crop > img").cropper("rotate", -45);
    }
  
    subirImagen(){

        var data =this.cropper.cropper("getCroppedCanvas");
        var baseImg = data.toDataURL("image/png");
        
        if(baseImg){
            var object = {
                'idConductor': this.conductor['idPersona'],
                'img': baseImg
            }

            console.log(object);
    
            loading_show();
            this.modalCancelarImagen();
            this.personaService.saveImage(object, (data: Result) => {
                loading_hide();
    
                if (data.isOk) {
                    //this.getConductores();
                    this.conductor = {placa:""};
                    jQuery("#placa").removeAttr("disabled");
                    this.vehiculo = null;
                    this.alertService.success(data.Mensaje);
                    this.getConductores();
                }else{
                    this.alertService.error(data.Mensaje);
                }
            });
        }else{
            alert("Por Favor Selecciona una imagen");
        }

    }

    onLoadImage(fileInput: any){
        this.crop =true;
        var $inputImage = jQuery("#inputImage");
        var fileReader = new FileReader(),
                        files = this.files,
                        file;

        var __this = this;
        
        if (fileInput.target.files && fileInput.target.files[0]) {
            
            file = fileInput.target.files[0];
            fileReader.readAsDataURL(file);
            if (/^image\/\w+$/.test(file.type)) {
            
                fileReader.onload = function () {
                    $inputImage.val("");
                    __this.cropper.cropper("reset", true).cropper("replace", this.result);
                };
            } else {
                alert("Escoge un archivo de Tipo imagen");
            }
            return ;
        }else{
            return
        }
        
    }

    initCropper(){
        this.cropper =   jQuery(".image-crop > img")
        this.cropper.css("max-width"," 100%");
        this.cropper.cropper({
            aspectRatio: 2/3,
            preview: ".img-preview",
            done: function(data) {
                // Output the result data for cropping image.
            }
        });

        //var $inputImage = jQuery("#inputImage");

    }

    probar(){
        loading_show();
        this.personaService.getCasino((data: any) => {
            loading_hide();
                console.log(data);
           
        });
    }
    
    getEmpresas() {
        loading_show();
        this.empresaService.getAll((data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.empresas = data.Content;
            }

        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    validarPlaca(event, isValid: boolean){
        if(event.keyCode == 13) {
            
            if(isValid == true){
                this.buscarPlaca();
            }else{
                this.alertService.error("Placa inválida, Escribelo en formato Correcto, Ej: ABC123 ó ABC12D");
            }
            
          }
        
    }

    limpiarPlaca(){
        
        jQuery("#placa").removeAttr("disabled");
        jQuery("#placa").focus();
        this.conductor.placa = "";
        this.vehiculo=null;
    }

    buscarPlaca(){
        
        this.vehiculoService.getByPlaca(this.conductor.placa,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.vehiculo = data.Content;
                
                if(this.vehiculo){
                    jQuery("#placa").attr("disabled","disabled");
                }else{
                    swal({
                        title: '¿Agregar Nuevo Vehiculo?',
                        text: "El vehiculo Con placas "+this.conductor.placa+" No Existe",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Si, Agregar Nuevo'
                      }).then(() => {
                        
                        let navigationExtras:  NavigationExtras;
                        navigationExtras= {
                            queryParams: this.conductor
                        };

                            this.router.navigate(['vehiculos'], navigationExtras);
                      })
                    //this.alertService.error("La palca no existe");
                }
                
            }

        });

    }

    files: FileList;
    getConductores() {
        loading_show();
        this.personaService.getAllByRol(3,(data: any) => {
            loading_hide();
            if (data.isOk) {
                
                this.conductores = data.Content;
            }

        });
    }

    getFiles(event: any) {
        this.files = event.target.files;
        for (var i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                continue;
            }
            var reader = new FileReader();
            reader.onload = (function (theFile) {
                return function (e) {
                    document.getElementById("image").innerHTML = ['<img class="animated bounceIn" style="width:60%; margin-left:20%" src="', e.target.result, '" />'].join('');
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    saveConductor() {
        //let formData: FormData = new FormData();

        /*if (!this.files) {
            this.alertService.warning('por favor cargar logo del empresa');
            return;
        }*/

        if (!this.conductor['estado']) {
            this.conductor['estado'] = 'ACTIVO';
        }

        if(!this.conductor['nombre'] || !this.conductor['apellidos'] || !this.conductor['cedula'] || !this.conductor['telefono']  || !this.conductor['email'] || !this.conductor['clave'] || !this.conductor['idEmpresa'] || !this.conductor['placa']){
            this.alertService.error("Debes Diligenciar todos los CAMPOS OBLIGATORIOS (*)");
            return;
        }

        if(this.vehiculo == null){

            this.alertService.error("Debes Seleccionar una placa (ESCRIBE LA PLACA Y PRESIONA ENTER)");
            return;

        }

        var object = {
            'nombre': this.conductor['nombre'],
            'apellidos': this.conductor['apellidos'],
            'cedula': this.conductor['cedula'],
            'direccion':this.conductor['direccion'],
            'telefono':this.conductor['telefono'],
            'fecha_nacimiento':this.conductor['fecha_nacimiento'],
            'idEmpresa':this.conductor['idEmpresa'],
            'email':this.conductor['email'],
            'clave':this.conductor['clave'],
            'estado': this.conductor['estado'],
            'rol':3,
            'placa': this.conductor['placa']
            
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.save(object, (data: Result) => {
            loading_hide();

            if (data.isOk) {
                this.getConductores();
                this.conductor = {placa:""};
                jQuery("#placa").removeAttr("disabled");
                this.vehiculo = null;
                this.alertService.success(data.Mensaje);
            }else{
                this.alertService.error(data.Mensaje);
            }
        });

    }

    showConductor(conductor: any) {
        this.conductor = conductor;
        this.update = true;
        this.buscarPlaca();
        jQuery("#clave").attr("disabled","disabled");
        jQuery("#t1").addClass("active");
        jQuery("#t2").removeClass("active");
        jQuery("#tab-1").addClass("active");
        jQuery("#tab-2").removeClass("active");
    }


    cancel() {
        this.conductor = this.conductores[0];
        this.update = false;
        jQuery("#clave").removeAttr("disabled");
        document.getElementById("image").innerHTML = '<div class="row">' +
            '<div class="col-lg-12" style="text-align: center;">' +
            '<i class="fa fa-image ico-bg"></i>' +
            '</div>' +
            '</div>';
    }

    updateConductor() {
        /*let formData: FormData = new FormData();

        if (this.files) {
            formData.append('imagen', this.files[0]);
        }*/


        if (!this.conductor['estado']) {
            this.conductor['estado'] = 'ACTIVO';
        }

        if(!this.conductor['nombre'] || !this.conductor['apellidos'] || !this.conductor['cedula'] || !this.conductor['telefono']  || !this.conductor['email'] || !this.conductor['idEmpresa'] || !this.conductor['placa']){
            this.alertService.error("Debes Diligenciar todos los CAMPOS OBLIGATORIOS (*)");
            return;
        }

        if(this.vehiculo == null){

            this.alertService.error("Debes Seleccionar una placa (ESCRIBE LA PLACA Y PRESIONA ENTER)");
            return;

        }

        var object = {
            'id': this.conductor['idPersona'],
            'nombre': this.conductor['nombre'],
            'apellidos': this.conductor['apellidos'],
            'cedula': this.conductor['cedula'],
            'direccion':this.conductor['direccion'],
            'telefono':this.conductor['telefono'],
            'fecha_nacimiento':this.conductor['fecha_nacimiento'],
            'idEmpresa':this.conductor['idEmpresa'],
            'email':this.conductor['email'],
            'estado': this.conductor['estado'],
            'rol':3,
            'placa': this.conductor['placa']
        }

        //formData.append('empresa', JSON.stringify(object));

        loading_show();
        this.personaService.update(object, (data: Result) => {
            loading_hide();
            console.log(data)
            if (data.isOk) {
                this.update = false;
                this.getConductores();
                this.conductor = {placa:""};
                this.vehiculo = null;
                jQuery("#placa").removeAttr("disabled");
                this.alertService.success(data.Mensaje);
                jQuery("#clave").removeAttr("disabled");

            }else{
                this.alertService.error(data.Mensaje);
            }
        });
    }


    updateState(id: number, state: string) {
        loading_show();
        var object = {
            'id': id,
            'estado': state
        }

        this.personaService.updateState(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Estado actualizado");
                this.getConductores();
            }
        });
    }

    modalClave(conductor:any) {

        this.modal2.open();
        this.conductor = conductor;

    }

    modalImagen(conductor:any) {

        this.modal3.open();
        this.conductor = conductor;

    }

    cambiarClave() {
        loading_show();
        var object = {
            'idUsuario': this.conductor.idUsuario,
            'clave': this.conductor.clave
        }

        this.personaService.cambiarClave(object, (data: Result) => {
            loading_hide();
            if (data.isOk) {
                this.alertService.success("Clave actualizada");
                this.getConductores();
                this.modal2.close();
            }
        });
    }


    modalCancelar(){
        this.conductor = {};
        this.modal2.close();
    }

    modalCancelarImagen(){
        this.conductor = {};
        this.modal3.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/views/conductores/conductores.component.ts